import React from "react";
import "./styles.scss";

import { Divider } from "@mui/material";

const OrderDetail = ({ data }) => {
  return (
    <div className="order-detail-container">
      <h3>Order details</h3>
      <Divider variant="middle" component="h3" />
      {data?.total?.overall_products?.length
        ? data?.total?.overall_products.map((item) => {
            return (
              <div className="summary-section">
                <div>
                  <p>
                    {item?.product_count} x {item?.name}
                  </p>
                  <span>
                    {item?.currency_symbol} {item?.total_price} {item?.currency}
                  </span>
                </div>
              </div>
            );
          })
        : null}
      <Divider variant="middle" component="div" />
      <div className="sub-total-section ">
        <div>
          <p>Sub - Total</p>
          <span>
            {data?.total?.currency_symbol} {data?.total?.sub_total}{" "}
            {data?.total?.currency}
          </span>
        </div>
        <div>
          <p>Shipping</p>
          <span>
            {data?.total?.currency_symbol} {data?.total?.shipping}{" "}
            {data?.total?.currency}
          </span>
        </div>
        {data?.total?.tax_name && (
          <div>
            <p>{data?.total?.tax_name}</p>
            <span>
              {data?.total?.currency_symbol} {data?.total?.tax_price}{" "}
              {data?.total?.currency}
            </span>
          </div>
        )}
      </div>
      <Divider variant="middle" component="div" />
      <div className="total">
        <p>Order Total</p>
        <span>
          {data?.total?.currency_symbol} {data?.total?.order_total}{" "}
          {data?.total?.currency}
        </span>
      </div>
    </div>
  );
};

export default OrderDetail;
